const ArticleShare = (() => {
  function handleCopyClick(button) {
    const url = button.getAttribute('data-share-url');
    if (!url) return;

    navigator.clipboard.writeText(url).then(() => {
      const copyIcon = button.querySelector('[data-icon="copy"]');
      const checkIcon = button.querySelector('[data-icon="check"]');
      if (copyIcon) copyIcon.classList.add('hidden');
      if (checkIcon) checkIcon.classList.remove('hidden');

      setTimeout(() => {
        if (copyIcon) copyIcon.classList.remove('hidden');
        if (checkIcon) checkIcon.classList.add('hidden');
      }, 2000);
    });
  }

  function init() {
    const buttons = document.querySelectorAll('[data-share-copy]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        handleCopyClick(button);
      });
    });
  }

  return {
    init,
  };
})();

document.addEventListener('DOMContentLoaded', ArticleShare.init);
